import { GridColumnType } from "./grid-column-type";
import { UserService } from "../../base-services/user.service";

export class GridColumnData{

    constructor(private userService: UserService){}

    Name: string;
    Label: string;
    Width: string;
    Type: GridColumnType;
    Format: string;
    Edit: boolean;
    Color: string;

    LoadGridColumnData(data: any){
        let gridColumnsData: GridColumnData[] = [];
        let gridColumnData: GridColumnData;
        if(data){
            data.forEach(column => {
                gridColumnData = new GridColumnData(this.userService);
                gridColumnData.Name = column.name;
                gridColumnData.Label = column.label;
                gridColumnData.Type = this.getType(column.type);
                gridColumnData.Width = this.getWidth(column.width);
                gridColumnData.Format = this.getFormat(column.format, gridColumnData.Type);
                gridColumnData.Edit = this.getEdit(column.edit);
                gridColumnData.Color = this.getColor(column.color);
                gridColumnsData.push(gridColumnData);
            })
        }
        return gridColumnsData;
    }

    private getType(type){
        if(type)
            return type;
        return GridColumnType.Text;
    }

    private getWidth(width){
        if(width)
            return width;
        return 'auto';
    }

    private getFormat(format, type){
        if(format)
            return format;
        switch(type){
            case GridColumnType.Text: return '';
            case GridColumnType.Number: return this.userService.GetNumberFormat();
            case GridColumnType.Date: return this.userService.GetDateFormat();
            case GridColumnType.DateTime: return this.userService.GetDateTimeFormat();
            case GridColumnType.Boolean: return '';
            case GridColumnType.DDL: return '';
            case GridColumnType.ZRC: return '';
            case GridColumnType.CheckBox: return '';
        }
    }

    private getEdit(edit){
        if(edit != null)
            return edit;
        return false;
    }

    private getColor(color){
        if(color)
            return color;
        return '';
    }
}